module.exports = __webpack_public_path__ + "static/media/3d-plan_DeepCBCT.babbae58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_DeepCBCT.svg
// module id = 1031
// module chunks = 0